(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-card-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-card-purchase')) {
    customElements.define('ms-card-purchase', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.updateVariant);
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.updateVariant);
      }
      updateVariant = (event) => {
        if (!event.target.matches('[data-ms-card-select]')) return;
        const option = event.target.selectedOptions[0];
        if (!option || option.disabled) return;
        this.querySelector('[data-ms-card-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-ms-card-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        this.querySelector('[name="quantity"]').value = option.dataset.quantity;
        const card = this.closest('product-card');
        card?.querySelectorAll('a[href*="/products/"]').forEach(link => {link.href = option.dataset.url;});
        if (!option.dataset.image) return;
        const alt = `${this.dataset.productTitle} — ${option.textContent.trim()}`;
        const button = this.querySelector('add-to-cart-component');
        if (button) button.dataset.productVariantMedia = option.dataset.image;
        // La foto principal cambia con la URL de la variante y conserva su srcset/sizes
        // (product-card.js del golden, 28-sep-2026): la tarjeta ya no pinta escondidas
        // las fotos de sus 10 presentaciones.
        if (card?.showVariantImage?.(option.dataset.image, alt)) return;
        // Respaldo para una tarjeta sin galería del tema: la foto va encimada.
        const gallery = card?.querySelector('.card-gallery');
        if (gallery) {
          let image = gallery.querySelector('.ms-card-variant-image');
          if (!image) {
            image = document.createElement('img');
            image.className = 'ms-card-variant-image';
            gallery.append(image);
          }
          image.alt = alt;
          image.src = option.dataset.image;
        }
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
